
import { useRouter } from '@nuxtjs/composition-api';
import type { Offer, ProductOffer as ProductOfferType } from '~/type/product/Product';
import ProductOffer from '~/components/ProductOffer/ProductOffer.vue';
interface Props {
  list: ProductOfferType[];
  path?: string;
}
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  path: {
    key: "path",
    required: false,
    type: String,
    default: '/'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const router = useRouter();
  function onOfferChange(offer: Offer, index: number): void {
    // eslint-disable-next-line vue/no-mutating-props
    props.list[index].active = offer;
    const oposite = getOposite(index);
    const id = getSimilar(offer.product, oposite?.product);
    if (id) router.push(`${props.path}${id}/`);else router.push(`${props.path}${offer.product?.[0]}/`);
  }
  function getOposite(index: number) {
    const opositeIndex = index === 0 ? 1 : 0;
    return props.list?.[opositeIndex]?.active;
  }
  function getSimilar(first: number[] = [], second: number[] = []) {
    return first.find(id => {
      return second.find(id2 => {
        return id === id2;
      });
    });
  }
  return {
    onOfferChange
  };
};
__sfc_main.components = Object.assign({
  ProductOffer
}, __sfc_main.components);
export default __sfc_main;
